// extracted by mini-css-extract-plugin
export default {"container":"SportCardStats_container__z2BTQ"};